export const BILDIRIM = {
  geciken: 'Parantezdeki sayı 48 saati geçen işleri gösterir.',
  baslik: 'Bildirimler', bos: 'Henüz bildiriminiz yok.', atama: 'Size bir müşteri atandı.',
  ac: 'Müşteriyi aç', okundu: 'Okundu işaretle', hata: 'Bildirimler yüklenemedi. Yeniden deneyin.',
  talepSahip: (saat: number) => `${String(saat)} saattir yanıt bekleyen web talebi.`,
  talepYonetici: (saat: number) => `Yükseltildi: ${String(saat)} saattir yanıt bekleyen web talebi.`,
  talepAc: 'Talebi aç',
  okunmamis: 'okunmamış bildirim', kapsam: 'Son 50 bildirim gösterilir.', yukleniyor: 'Bildirimler yükleniyor.',
} as const;
